// Conditions we treat — grouped by category with descriptive images.
import {
  Sparkles,
  Scissors,
  Footprints,
  HeartPulse,
  Leaf,
} from "lucide-react";

export const CONDITION_CATEGORIES = [
  {
    id: "skin",
    title: "Skin Conditions",
    icon: Sparkles,
    image:
      "https://images.unsplash.com/photo-1637662722004-68be528ef359?fm=jpg&q=85&w=1200&auto=format&fit=crop&ixlib=rb-4.1.0",
    blurb:
      "Common foot skin issues we assess, treat and educate you about — from corns to fungal infections.",
    items: [
      { name: "Corns", desc: "Small areas of thickened skin caused by pressure or friction, often painful when walking." },
      { name: "Calluses & Hard Skin", desc: "Thickened skin that develops from repeated pressure or rubbing on the feet." },
      { name: "Cracked Heels", desc: "Dry, split skin around the heels that can become painful or sore." },
      { name: "Dry Skin", desc: "Rough, flaky skin caused by dehydration, weather, or skin conditions." },
      { name: "Athlete's Foot", desc: "A common fungal infection causing itching, peeling, and irritation between the toes." },
      { name: "Fungal Skin Infections", desc: "Skin infections caused by fungi, often leading to redness, itching, and scaling." },
      { name: "Sweaty Feet", desc: "Excessive sweating of the feet that may lead to discomfort, odour, or infection." },
      { name: "Blisters", desc: "Fluid-filled pockets caused by friction, pressure, or poorly fitting footwear." },
      { name: "Foot Odour", desc: "Persistent unpleasant smell caused by sweat and bacteria on the feet." },
      { name: "Peeling or Irritated Skin", desc: "Skin that becomes flaky, sore, or inflamed due to dryness, irritation, or infection." },
    ],
  },
  {
    id: "nails",
    title: "Nail Conditions",
    icon: Scissors,
    image:
      "https://customer-assets.emergentagent.com/job_foot-health-pro-2/artifacts/zceq9uw9_IMG_1949.jpeg",
    blurb:
      "Specialist nail care — from routine trimming to advanced management of fungal and ingrown nails.",
    items: [
      { name: "Thickened Nails", desc: "Toenails that become thick, hard, and difficult to cut over time." },
      { name: "Fungal Nails", desc: "A fungal nail infection causing thickened, discoloured, or brittle nails." },
      { name: "Ingrown Toenails", desc: "A painful condition where the nail grows into the surrounding skin." },
      { name: "Curved or Painful Nails", desc: "Toenails that curl or press into the skin, causing discomfort or pressure." },
      { name: "Damaged or Discoloured Nails", desc: "Nails affected by trauma, infection, or underlying health conditions." },
      { name: "Brittle Nails", desc: "Weak or split nails that crack, peel, or break easily." },
      { name: "Nail Psoriasis", desc: "A condition causing pitting, thickening, or discolouration of the nails." },
      { name: "Overgrown Nails", desc: "Toenails that become excessively long and difficult to manage safely." },
    ],
  },
  {
    id: "toes",
    title: "Toe & Foot Problems",
    icon: Footprints,
    image:
      "https://images.unsplash.com/photo-1678396618095-7be9f0fa49b3?fm=jpg&q=85&w=1200&auto=format&fit=crop&ixlib=rb-4.1.0",
    blurb:
      "Conservative management of structural toe issues — easing pressure points and improving comfort.",
    items: [
      { name: "Bunions", desc: "A bony bump at the side of the big toe joint that can cause pain and pressure." },
      { name: "Hammer Toes", desc: "Bent toes caused by muscle imbalance, often leading to rubbing and discomfort." },
      { name: "Claw Toes", desc: "Toes that curl downward, creating pressure points and shoe discomfort." },
      { name: "Overlapping Toes", desc: "Toes that overlap each other, often causing irritation and pressure." },
      { name: "Corns Between Toes", desc: "Soft or painful corns that develop between the toes due to friction." },
    ],
  },
  {
    id: "diabetic",
    title: "Diabetic & Circulation Care",
    icon: HeartPulse,
    image:
      "https://customer-assets.emergentagent.com/job_foot-health-pro-2/artifacts/hv7ap2yu_IMG_1950.jpeg",
    blurb:
      "Routine assessments and preventative care for people living with diabetes or circulation concerns.",
    items: [
      { name: "Diabetic Foot Checks", desc: "Routine assessments to help prevent diabetic foot complications." },
      { name: "Neurovascular Assessments", desc: "Checks of circulation and nerve function to monitor overall foot health." },
      { name: "Circulation Monitoring", desc: "Assessment of blood flow to help identify vascular concerns early." },
      { name: "Preventative Diabetic Foot Care", desc: "Regular foot care designed to reduce the risk of diabetic foot problems." },
    ],
  },
  {
    id: "routine",
    title: "Routine Foot Care",
    icon: Leaf,
    image:
      "https://images.unsplash.com/photo-1545463913-5083aa7359a6?fm=jpg&q=85&w=1200&auto=format&fit=crop&ixlib=rb-4.1.0",
    blurb:
      "Maintenance treatments to keep feet comfortable, healthy and supporting your everyday mobility.",
    items: [
      { name: "Toenail Cutting", desc: "Safe trimming and maintenance of toenails to improve comfort and foot health." },
      { name: "General Foot Care", desc: "Routine treatment to maintain healthy, comfortable feet." },
      { name: "Elderly Foot Care", desc: "Specialised foot care for older adults to support mobility and comfort." },
      { name: "Footwear Advice", desc: "Professional guidance on choosing supportive and comfortable footwear." },
    ],
  },
];
